module.exports = __webpack_public_path__ + "static/img/csss.adea220c.png";